import { useEffect } from 'react';

const OPEN = '.bx-menu, .bx-pop';

/** The control that opened a floating menu: the expanded one closest to it. */
function triggerOf(menu: Element): HTMLElement | null {
  let el = menu.parentElement;
  for (let depth = 0; el && depth < 3 && !el.matches('main, body'); depth++, el = el.parentElement) {
    const found = [...el.querySelectorAll<HTMLElement>('[aria-expanded="true"]')].filter((x) => !menu.contains(x));
    if (found.length) return found[found.length - 1];
  }
  return null;
}

/**
 * Closes floating menus the way people expect: a press outside or Escape. Every menu of the design
 * keeps its open state in the page, so this presses the same control that opened it; pressing that
 * control itself keeps working as a toggle.
 */
export function MenuDismiss() {
  useEffect(() => {
    const closeAll = (target: Element | null) => {
      for (const menu of document.querySelectorAll(OPEN)) {
        if (target && menu.contains(target)) continue;
        const trigger = triggerOf(menu);
        if (trigger && !(target && trigger.contains(target))) trigger.click();
      }
    };
    const onDown = (e: PointerEvent) => closeAll(e.target as Element);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeAll(null);
    };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onKey, true);
    return () => {
      document.removeEventListener('pointerdown', onDown, true);
      document.removeEventListener('keydown', onKey, true);
    };
  }, []);
  return null;
}
